<template>
  <div class="order-info-container" v-loading="loading">
    <div class="main">
      <div class="form-warp">
        <div class="title">
          {{ nodeData.nodeData.func_form_name }}
        </div>
        <OrderLineInfo v-if="lineData" :data="lineData"/>

        <div style="margin: 10px 20px">
          <PcParser
            v-if="formDesignData"
            ref="dialogForm"
            :form-data="formDesignData"
            :displayData="displayData"
            :editFields="editFields"
            :disabled="formDisabled"
            :needFlow="!!needFlow"
            :moduleUuid="moduleUuid"
            :formMode="formMode"
            @submit="onFormSubmit"
            @on-close="onEndFlow"
          ></PcParser>
        </div>
      </div>
      <div class="info-warp">
        <Tabs v-model="activeName" class="order-info-tabs">
          <TabPane label="表单动态" name="first">
            <Dynamic v-if="dynamicData" :taskTodo="dynamicData" />
          </TabPane>
          <TabPane label="留言" style="height: 100%" name="second">
            <Message :node-data="nodeData" />
          </TabPane>
        </Tabs>
      </div>
    </div>
    <div class="action-row">
<!--      <el-button type="primary" style="padding: 10px 34px" v-if="canSubmit" @click="triggerSubmit">
        填写表单
      </el-button>-->
    </div>
  </div>
</template>
<script>
/**
 * @description 共单子项详情
 */
import OrderLineInfo from '@/views/workOrder/components/orderLineInfo/index.vue'
import Dynamic from '@/views/workOrder/components/dynamic/index.vue'
import Message from '@/views/workOrder/components/message/index.vue'
import { Tabs, TabPane } from 'element-ui'
import {formDesign} from "@/apis/data/workflow";
import {dataInterface, transFieldsUUid} from "@/apis/data";
export default{
  name: 'OrderInfo',
  components: { Tabs,  TabPane, Dynamic, OrderLineInfo, Message },
  props:['nodeData'],
  data() {
    return {
      activeName: 'first',
      formDesignData: null,
      formDisabled: true,
      displayData: {},
      editFields: {},
      needFlow: false,
      moduleUuid: '',
      formMode: 'add',
      loading: true,
      dynamicData: null,
      lineData: null,
    }
  },
  mounted() {
    this.dynamicData = [this.nodeData] // 任务动态
    this.initParser()
  },
  watch:{
    nodeData:{
      handler(){
        this.dynamicData = [this.nodeData] // 任务动态
        this.initParser()
      },
      deep: true
    }
  },
  computed:{
    canSubmit(){
      const userInfo = this.$GetUserInfo()
      if(this.nodeData.userWait.is_deal === 0 && this.nodeData.userWait.user_id === userInfo.id){
        return true
      }
      return false
    }
  },
  methods:{
    initParser(){
      const user = Array.from(this.nodeData.user_task,item=>item.user_name)
      const lineData = {
        func_form: this.nodeData.nodeData.func_form,
        status: this.nodeData.userWait.is_deal,
        deadline: this.nodeData.nodeData.deadline,
        target_users: user.join(',')
      }
      this.lineData = lineData
      this.loading = true
      this.formDesignData = null
      let taskFormId = this.nodeData?.userWait?.task_form_id
      const nodeData = this.nodeData.nodeData
      if(nodeData.form_type === 1){
        formDesign.formShow(this.nodeData.nodeData.func_form).then(res=>{
          if(res.data.code === 200){
            const formData = res.data.data
            if(taskFormId > 0){
              formDesign.formDataDetail(taskFormId).then(res1=> {
                if (res1.data.code === 200) {
                  this.displayData = res1.data.data;
                  this.formDesignData = JSON.parse(formData.json)
                  this.needFlow = !!formData.need_flow
                  this.moduleUuid = formData.module_uuid
                  this.loading = false
                }
              })
            } else {
              this.formDesignData = JSON.parse(formData.json)
              this.needFlow = !!formData.need_flow
              this.moduleUuid = formData.module_uuid
              this.loading = false
            }
          }
        });
      } else if(nodeData.form_type === 2){
        const objectUuid = this.nodeData?.nodeData?.object_uuid
        const formUuid = this.nodeData?.nodeData?.func_form
        transFieldsUUid(objectUuid, formUuid).then((res) => {
          if (res.data.code == 200) {
            this.needFlow = !!res.data.data.need_flow;
            this.moduleUuid = formUuid || objectUuid
            this.needParentFlow = !!res.data.data.need_parent_flow;
            if(taskFormId > 0){
              let config = res.data.data;
              let ruuids = [];
              for (let i = 0; i < config.fields.length; i++) {
                let item = config.fields[i];
                if (item.__config__.tagIcon == 'form') {
                  ruuids.push({ relationship_uuid: item.__vModel__ });
                }
              }
              dataInterface({
                object_uuid: objectUuid,
                data_id: taskFormId,
                ruuids,
                __method_name__: 'dataInfo'
              }).then((res1) => {
                let data = res1.data.data;
                this.formDesignData = res.data.data;
                this.displayData = data;
                if (data.editFields instanceof Array) {
                  this.editFields = {};
                } else {
                  this.editFields = data.editFields || {};
                }
                this.loading = false;
              })
            } else {
              this.formDesignData = res.data.data;
              this.loading = false;
            }
          }
        })
      } else if(nodeData.form_type === 3){
        console.log('手写系统表单')
      }
    },
    onEndFlow(){},
    triggerSubmit(){
      this.$refs.dialogForm.handleSubmit()
    },
    onFormSubmit(formData){
      if(this.nodeData.nodeData.form_type === 1){
        formData.task_log_id = this.taskTodoId
        formData.module_uuid = this.moduleUuid
        console.log(JSON.stringify(formData), 222333)
        formDesign.formDataStore(formData).then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
  }
}
</script>
<style lang="less" scoped>
  .order-info-container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    .main{
      flex-grow: 1;
      height: 10px;
      display: flex;
      .form-warp{
        flex-grow: 1;
        width: 10px;
        height: 100%;
        overflow-y: auto;
        .title{
          padding: 12px 24px;
          box-sizing: border-box;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #272829;
          line-height: 22px;
        }
      }
      .info-warp{
        width: 392px;
        height: 100%;
        border-left: 1px solid #f1f1f1;
        .order-info-tabs{
          height: 100%;
          :deep(.el-tabs__header) {
            padding: 0 10px;
            box-sizing: border-box;
          }
          :deep(.el-tabs__nav-wrap::after) {
            height: 0;
          }
          :deep(.el-tabs__content) {
            height: calc(100% - 55px);
            overflow: auto;
          }
        }
      }
    }
    .action-row{
      width: 100%;
      height: 64px;
      padding: 0 24px;
      border-top: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
    }
  }
</style>
